var render, staticRenderFns
var script = {}
import style0 from "./style.vue?vue&type=style&index=0&id=20a67916&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a67916",
  null
  
)

export default component.exports